/**
 * Stable browser identifier persisted in localStorage. Stage-1 simplification —
 * upgrades to FingerprintJS open-source build during Tue's anti-abuse pass.
 * The server-side bucket key already mixes this with the IP, so a re-installed
 * browser still shares a bucket with the same IP for the day.
 */
const STORAGE_KEY = 'jas:fp';

export function getFingerprint(): string {
  if (typeof window === 'undefined') return 'ssr';
  let fp = window.localStorage.getItem(STORAGE_KEY);
  if (!fp) {
    fp = crypto.randomUUID();
    window.localStorage.setItem(STORAGE_KEY, fp);
  }
  return fp;
}
